@import '../../style/breakpoints';

:host {
    --wcs-nav-background-color: var(--wcs-semantic-color-background-surface-brand);
    --wcs-nav-width-desktop: calc(12 * var(--wcs-semantic-size-base));
    --wcs-nav-height-mobile: calc(6 * var(--wcs-semantic-size-base));
}

nav {
    background-color: var(--wcs-nav-background-color);
    display: flex;
    z-index: 1055;
    flex-direction: column;
    width: var(--wcs-nav-width-desktop);
    height: 100%;
    overflow: auto;
    scrollbar-width: thin;

    div[role="list"] {
        list-style-type: none;
        display: flex;
        flex-direction: column;
        flex-grow: 1;

        @include for-tablet-landscape-down {
            flex-direction: row;
        }
    }

    @include for-tablet-landscape-down {
        flex-direction: row;
        width: 100%;
        height: var(--wcs-nav-height-mobile);
    }
}

::slotted(wcs-nav-item) {
    @include for-tablet-landscape-down {
        flex: 1;
    }
}

// Place bottom items at the bottom
slot[name=bottom],
// Same for ff < 63
wcs-nav-item:not([slot=bottom]) + wcs-nav-item[slot=bottom] {
    @include for-desktop-up {
        display: block;
        margin-top: auto;
    }
}
